
export default class ClipModel {
  constructor(clipCount) {
    this.clipCount = clipCount;
    this.searchQuery = 'https://www.googleapis.com/youtube/v3/search?key=AIzaSyDgg61Rp7mefcTkDX8MQOhY1axnva2chw0&type=video&part=snippet&order=viewCount&maxResults=15&q=dota';
    this.searchQueryForView = 'https://www.googleapis.com/youtube/v3/videos?key=AIzaSyDgg61Rp7mefcTkDX8MQOhY1axnva2chw0&id=LUL1nnxUz_c&part=snippet,statistics';
    this.searchQueryForToken = '';
    this.nextPageToken = ' ';
  }

  async getData() {
    const url = this.searchQuery;

    const responce = await fetch(url);
    const data = await responce.json();
    return data;
  }

  static extractClipNames(data) {
    return data.items.map(clip => clip.snippet.title);
  }

  static extractClipImg(data) {
    return data.items.map(clip => clip.snippet.thumbnails.high.url);
  }

  static extractClipChannel(data) {
    return data.items.map(clip => clip.snippet.channelTitle);
  }

  static extractClipDate(data) {
    return data.items.map(clip => clip.snippet.publishedAt.substring(0, 10));
  }

  static extractClipViews(data) {
    return data.items.map(clip => clip.statistics.viewCount);
  }

  static extractClipDescription(data) {
    return data.items.map(clip => clip.snippet.description);
  }

  static extractClipId(data) {
    return data.items.map(clip => clip.id.videoId);
  }

  static extractClipNextTocken(data) {
    alert(data.nextPageToken);
    return data.nextPageToken;
  }

  creatClipList() {
    const clipArr = new Array(this.clipCount);
    clipArr.fill(`<li class="information-item empty-clip">
      <img class="information-item__img" src="" alt="">
      <a href="#" target="_blank" class="information-item__title red-stylized-button">Lorem, ipsum dolor.</a>
      <div class="information-item__channel-characteristics"><span
              class="channel-characteristics__icon"><i class="fas fa-male"></i></span><span
              class="channel-characteristics__value channel-name">CodeCor</span>
      </div>
      <div class="information-item__channel-characteristics"><span
              class="channel-characteristics__icon"><i class="far fa-calendar-alt"></i></span><span
              class="channel-characteristics__value clip-date">11-02-19</span></div>
      <div class="information-item__channel-characteristics"><span
              class="channel-characteristics__icon"><i class="far fa-eye"></i></span><span
              class="channel-characteristics__value clip-view">2348</span></div>
      <p class="information-item__description">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corrupti exercitationem tenetur
          minima!
          Sequi optio adipisci itaque architecto quas neque pariatur quia inventore porro natus. At.
      </p>
  </li>`);
    return clipArr;
  }

  async setClipNames() {
    const url = this.searchQuery;
    const responce = await fetch(url);
    const data = await responce.json();
    const clipTitleList = document.querySelectorAll('.empty-clip .information-item__title');
    const titleList = ClipModel.extractClipNames(data);
    const idList = ClipModel.extractClipId(data);
    idList.forEach((id, index) => {
      const link = `https://www.youtube.com/watch?v=${id}`;
      clipTitleList[index].href = link;
      clipTitleList[index].innerHTML = titleList[index];
    });
  }

  async setClipImg() {
    const url = this.searchQuery;
    const responce = await fetch(url);
    const data = await responce.json();
    this.nextPageToken = data.nextPageToken;
    const imgList = ClipModel.extractClipImg(data);
    const clipImgList = document.querySelectorAll('.empty-clip .information-item__img');
    clipImgList.forEach((img, index) => {
      const imgBuf = img;
      imgBuf.src = imgList[index];
    });
  }

  async setClipChannel() {
    const url = this.searchQuery;
    const responce = await fetch(url);
    const data = await responce.json();
    const channelList = ClipModel.extractClipChannel(data);
    const clipChannelList = document.querySelectorAll('.empty-clip .channel-name');
    clipChannelList.forEach((channel, index) => {
      const channelBuf = channel;
      channelBuf.textContent = channelList[index];
    });
  }

  async setClipDate() {
    const url = this.searchQuery;
    const responce = await fetch(url);
    const data = await responce.json();
    const dateList = ClipModel.extractClipDate(data);
    const clipDateList = document.querySelectorAll('.empty-clip .clip-date');
    clipDateList.forEach((date, index) => {
      const dateBuf = date;
      dateBuf.textContent = dateList[index];
    });
  }

  async setClipDescription() {
    const url = this.searchQuery;
    const responce = await fetch(url);
    const data = await responce.json();
    const descriptionList = ClipModel.extractClipDescription(data);
    const clipDescriptionList = document.querySelectorAll('.empty-clip .information-item__description');
    clipDescriptionList.forEach((description, index) => {
      const descriptionBaf = description;
      descriptionBaf.textContent = descriptionList[index];
    });
  }

  async getClipIdString() {
    const url = this.searchQuery;
    const responce = await fetch(url);
    const data = await responce.json();
    const clipIdString = ClipModel.extractClipId(data).join(',');
    return clipIdString;
  }

  async setSearchQueryForView() {
    const clipIdString = await this.getClipIdString();
    const query = `https://www.googleapis.com/youtube/v3/videos?key=AIzaSyDgg61Rp7mefcTkDX8MQOhY1axnva2chw0&id=${clipIdString}&part=snippet,statistics`;
    return query;
  }

  async setClipView() {
    this.searchQueryForView = await this.setSearchQueryForView();
    const url = this.searchQueryForView;
    const responce = await fetch(url);
    const data = await responce.json();
    const viewList = ClipModel.extractClipViews(data);
    const clipViewList = document.querySelectorAll('.empty-clip .clip-view');
    clipViewList.forEach((value, index) => {
      const valueBaf = value;
      valueBaf.textContent = `${viewList[index]} `;
    });
    clipViewList.forEach(elem => elem.parentNode.parentNode.classList.remove('empty-clip'));
  }

  async setClipNextTocken() {
    const url = this.searchQuery;
    const responce = await fetch(url);
    const data = await responce.json();
    console.log(data);
  }
}
